module.exports = __webpack_public_path__ + "static/slack-dcf1b499b0872590cf7f7570df166598.png";